module.exports = __webpack_public_path__ + "static/media/brightening.3ad3f868.svg";